import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'

import Box from 'components/_new/layout/Box/Box'
import Text from 'components/_new/typography/Text/Text'

import messages from './messages'
import s from './ApplePayButtonView.scss'


const ApplePayButtonView = ({ withInfo, onClick, isTitleBuy, isTitleSetup, height, className }) => {
  const buttonClassName = cx(s.applePayButton, {
    [s.titleBuy]: isTitleBuy,
    [s.titleSetup]: isTitleSetup,
  })

  return (
    <div className={className}>
      <div className={buttonClassName} style={{ height }} onClick={onClick} />
      {
        withInfo && (
          <Box pt="4">
            <Text message={messages.info} tag="small" />
          </Box>
        )
      }
    </div>
  )
}

ApplePayButtonView.propTypes = {
  withInfo: PropTypes.bool,
  onClick: PropTypes.func,
  isTitleBuy: PropTypes.bool,
  isTitleSetup: PropTypes.bool,
  height: PropTypes.string,
}

ApplePayButtonView.defaultProps = {
  height: '45px',
}


export default ApplePayButtonView
